// function makeAlert (message, status) {
//     if(typeof status === "undefined") {
//         status = "success"
//     }
//
//     if(!["primary","secondary","success","danger","warning","info","light","dark"].includes(status)) {
//         status = "dark"
//     }
//
//     let html =
//         '<div class="alert alert-dismissible" role="alert">'+
//         '   <div class="message"></div>'+
//         '   <button type="button" class="close" data-dismiss="alert" aria-label="Close">'+
//         '       <span aria-hidden="true">×</span>'+
//         '   </button>'+
//         '</div>'
//
//     let appended_element = $.parseHTML(html)
//
//     $('.toast_container').append(appended_element)
//
//     $(appended_element).addClass('alert-'+status)
//     $(appended_element).find("div.message").text(message)
//
//     $(appended_element).show()
// }

export default function makeAlert(message, status, timer = null, callback = null) {
    let $dynamicAlerts = $('div#dynamic-alerts');

    if($dynamicAlerts.text().indexOf(message) !== -1) {
        console.log("This message is already displayed: " + message);
        return false;
    }

    if (typeof status === 'undefined') {
        status = 'success';
    }

    if (!['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'].includes(status)) {
        status = 'dark';
    }

    let html =
        '<div class="alert alert-dismissible" role="alert">' +
        '   <div class="message" style="white-space: pre-wrap; overflow-wrap: break-word;"></div>' +
        '   <button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '       <span aria-hidden="true">×</span>' +
        '   </button>' +
        '</div>';

    let appended_element = $.parseHTML(html);

    $dynamicAlerts.append(appended_element);
    $(appended_element).addClass('alert-' + status).find('div.message').text(message);

    if (/^[0-9]+$/.test(timer)) {
        setTimeout(function() {
            $(appended_element).hide(250, function() {
                $(appended_element).remove();
            });

            if (typeof callback === 'function') {
                callback();
            }
        }, timer);
    }
}
